import React from "react";
import Grid from "@material-ui/core/Grid";
import * as DatiFide from "src/DatiFide";
import { _CalculationCard } from "../../components";
import { CCalculationField } from "./CalculationCard";

interface ICalculationSectionProps {
    Data: DatiFide.CDatiFideValutazione;
    OnChange: (e: string, val: string) => void;
}

export const _CalculationSection: React.FC<ICalculationSectionProps> = ({ Data, OnChange }) => {
    return (
        <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
                <_CalculationCard
                    Title="Copertura patrimoniale"
                    Id="CalcolatoPatrimoniale"
                    FieldA={new CCalculationField("Dato.ImportoAffidamento", "Importo affidamento", Data.ImportoAffidamento)}
                    FieldB={new CCalculationField("Dato.PatrimonioNetto", "Patrimonio netto", Data.PatrimonioNetto)}
                    AcceptableLimit={5}
                    GoodLimit={1}
                    LowLimit={5}
                    OnChange={OnChange}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <_CalculationCard
                    Title="Redditivita"
                    Id="CalcolatoRedditivita"
                    FieldA={new CCalculationField("Dato.MargineOperativo", "Margine Operativo", Data.MargineOperativo)}
                    FieldB={new CCalculationField("Dato.PatrimonioNetto", "Patrimonio netto", Data.PatrimonioNetto)}
                    AcceptableLimit={0.03}
                    GoodLimit={0.1}
                    LowLimit={0.03}
                    OnChange={OnChange}
                    ReverseDirection
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <_CalculationCard
                    Title="Situazione finanziaria"
                    Id="CalcolatoSituazioneFinanziaria"
                    FieldA={new CCalculationField("Dato.AttivoCircolante", "Attivo circolante", Data.AttivoCircolante)}
                    FieldB={new CCalculationField("Dato.DebitiBreve", "Debiti a breve", Data.DebitiBreve)}
                    AcceptableLimit={0.85}
                    GoodLimit={1}
                    LowLimit={0.85}
                    OnChange={OnChange}
                    ReverseDirection
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <_CalculationCard
                    Title="Equilibrio patrimoniale"
                    Id="CalcolatoEquilibrioPatrimoniale"
                    FieldA={new CCalculationField("Dato.TotalePassivo", "Totale passivo", Data.TotalePassivo)}
                    FieldB={new CCalculationField("Dato.PatrimonioNetto", "Patrimonio netto", Data.PatrimonioNetto)}
                    AcceptableLimit={7}
                    GoodLimit={2.5}
                    LowLimit={7}
                    OnChange={OnChange}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <_CalculationCard
                    Title="Operatività"
                    Id="CalcolatoOperativita"
                    FieldA={new CCalculationField("Dato.ValoreProduzione", "Valore Produzione", Data.ValoreProduzione)}
                    FieldB={new CCalculationField("Dato.AttivoCircolante", "Attivo circolante", Data.AttivoCircolante)}
                    AcceptableLimit={0.5}
                    GoodLimit={1.5}
                    LowLimit={0.5}
                    OnChange={OnChange}
                    ReverseDirection
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <_CalculationCard
                    Title="Andamento dell'attività di produzione"
                    Id="CalcolatoAndamento"
                    FieldA={new CCalculationField("Dato.ValoreProduzione", "Ultimo anno", Data.ValoreProduzione)}
                    FieldB={new CCalculationField("Dato.ValoreProduzionePrecedente", "Anno precedente", Data.ValoreProduzionePrecedente)}
                    AcceptableLimit={0.75}
                    GoodLimit={1.1}
                    LowLimit={0.75}
                    OnChange={OnChange}
                    ReverseDirection
                />
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsAssessment/CalculationSection.tsx